import {createSlice} from "@reduxjs/toolkit";

const initialSchThesisesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  schThesisForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const schThesisesSlice = createSlice({
  name: "schThesises",
  initialState: initialSchThesisesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSchThesisById
    schThesisFetched: (state, action) => {
      state.actionsLoading = false;
      state.schThesisForEdit = action.payload.schThesisForEdit;
      state.error = null;
    },
    // findSchThesises
    schThesisesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createSchThesis
    schThesisCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.schThesis);
    },
    // updateSchThesis
    schThesisUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schThesisId === action.payload.schThesis.schThesisId) {
          return action.payload.schThesis;
        }
        return entity;
      });
    },
    // deleteSchThesis
    schThesisDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schThesisId !== action.payload.schThesisId);
    },
    // deleteSchThesises
    schThesisesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schThesisId)
      );
    },
  }
});
